import { createSlice } from "@reduxjs/toolkit";

const isLogin_local = sessionStorage.getItem("isLogin");
const Atoken = sessionStorage.getItem("access_token");
const Rtoken = sessionStorage.getItem("refresh_token");
const Sexpire = sessionStorage.getItem("timeOut");
const localdata = JSON.parse(sessionStorage.getItem("userdata"));
// const permissions = JSON.parse(sessionStorage.getItem("permission"));
let access_token = isLogin_local ? Atoken : "";
let refresh_token = isLogin_local ? Rtoken : "";
let timeOut = isLogin_local ? Sexpire : "";
// let recordsPerPage = isLogin_local
//   ? Number(localdata.Settings[1].te_settings_value)
//   : 10;

//permission
const Adding = sessionStorage.getItem("AddPermission");
const Editing = sessionStorage.getItem("EditPermission");
const Deleting = sessionStorage.getItem("DeletePermission");
const Viewing = sessionStorage.getItem("ViewPermission");
const Downloading = sessionStorage.getItem("DownloadPermission");

let Adding_Permission = isLogin_local ? parseInt(Adding) : "";
let Edit_Permission = isLogin_local ? parseInt(Editing) : "";
let View_Permission = isLogin_local ? parseInt(Viewing) : "";
let Download_Permission = isLogin_local ? parseInt(Downloading) : "";
let Delete_Permission = isLogin_local ? parseInt(Deleting) : "";

const initialState = {
  accessTocken: access_token,
  refreshTocken: refresh_token,
  urlString: "localhost",
  o365token: "",
  userType: "",
  timeOut: timeOut,
  // recordsPerPage: recordsPerPage,
  sidebarToggle: false,

  //permissions
  Add_Permission: Adding_Permission,
  Delete_Permission: Delete_Permission,
  Download_Permission: Download_Permission,
  Edit_Permission: Edit_Permission,
  View_Permission: View_Permission,
};
export const tockenReducerInner = createSlice({
  name: "AccessTocken",
  initialState: initialState,
  reducers: {
    accessTocken(state, action) {
      state.accessTocken = action.payload;
    },
    refreshTocken(state, action) {
      state.refreshTocken = action.payload;
    },
    O365token(state, action) {
      state.o365token = action.payload;
    },
    userType(state, action) {
      state.userType = action.payload;
    },
    timeOut(state, action) {
      state.timeOut = action.payload;
    },
    // recordsPerPage(state, action) {
    //   state.recordsPerPage = action.payload;
    // },
    sidebar_toggle(state, action) {
      state.sidebarToggle = action.payload;
    },

    //PERMISSION ACCORDING TO ROLES
    Add_Perminssion(state, action) {
      state.Add_Permission = action.payload;
    },
    Delete_Permission(state, action) {
      state.Delete_Permission = action.payload;
    },
    Download_Permission(state, action) {
      state.Download_Permission = action.payload;
    },
    Edit_Permission(state, action) {
      state.Edit_Permission = action.payload;
    },
    View_Permission(state, action) {
      state.View_Permission = action.payload;
    },
  },
});
